import { STORE_GROUPERS } from "../../../other/utils/otherUtils";

/**
 * This mixin implements functionality to persist and restore custom grouper.
 *
 * We cannot serialize function itself, therefore we persist function name and arguments to generate
 * a new grouper function. Grouper function generator is stored in the globally accessible `STORE_GROUPERS`
 * object. Key in this object is a name of the function we use to group the store. When we save state we
 * save name of the function (key in this object) and arguments which are supposed to be passed to the
 * function generator. When we restore state, we look up key in this global object and pass saved args to
 * the function generator. Then we group store by it.
 *
 * Every store which uses custom groupers should utilize this mixin.
 */
export const SwivuSortedGroupersMixin = Target => class SwivuSortedGroupersMixin extends Target {
  getState() {
    const state = super.getState();

    const { groupers } = this;

    state.groupers?.forEach(stateGrouper => {
      const storeGrouper = groupers.find(g => g.field === stateGrouper.field);

      const { fn } = storeGrouper;

      // Check if store grouper function is a special one
      if (fn?.stateful) {
        stateGrouper.custom = true;
        stateGrouper.fnName = fn.fnName;
        stateGrouper.args = fn.args;
      }
    });

    return state;
  }

  applyState(state) {
    if (state.groupers) {
      // Split groupers into arrays of custom and defaults
      const groupers = state.groupers.slice().filter(r => r.custom);

      state.groupers = state.groupers.filter(r => !r.custom);

      // Apply state with default groupers only
      super.applyState(state);

      // Process custom groupers which use functions
      groupers.forEach(grouper => {
        if (grouper.fnName in STORE_GROUPERS) {
          this.group({
            field: grouper.field,
            ascending: grouper.ascending,
            fn: STORE_GROUPERS[grouper.fnName](...grouper.args)
          });
        }
        else {
          console.warn("Trying to restore grouper, cannot find suitable grouping function");
        }
      });
    }
    else {
      super.applyState(state);
    }
  }
}
